// -----------------------
// Product Customizations
// -----------------------

// DOM Ready
function documentReady(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

const cr = {
    variantsSelected: function(type){
        let variantSelectors;
        if (type === 'radio'){
            variantSelectors = document.querySelector('variant-radios');
            const fieldsets = variantSelectors.querySelectorAll('fieldset');
            let values = [];
            fieldsets.forEach(fieldset => {
                const inputs = fieldset.querySelectorAll('input');
                inputs.forEach(input => {
                    if (input.checked){
                        values.push(input.getAttribute('value'));
                    }

                });
            });
            return values;
        }
        if (type === 'select'){
            variantSelectors = document.querySelectorAll('variant-selects select');
            let values = [];
            variantSelectors.forEach(select => {
                const selectedOption = select.options[select.selectedIndex];
                values.push(selectedOption.value);
            });
            return values;
        }

    },
    updateSelectedPrice: function(variantsSelected) {
    const matchingVariant = cr.matchingVariant(variants, variantsSelected);

    if (!matchingVariant) {
        return;
    }

    const compareAtPrice = parseInt(matchingVariant.compare_at_price) || 0;
    const regularPrice = parseInt(matchingVariant.price) || 0;

    const priceSaleElement = document.querySelector('.price__sale');

    if (!priceSaleElement) {
        return;
    }

    const salePriceElement = priceSaleElement.querySelector('.price-item--sale');
    const compareElement = priceSaleElement.querySelector('s.price-item--regular');

    if (compareElement) {
        if (compareAtPrice > regularPrice) {
            compareElement.style.display = 'inline';
            compareElement.innerHTML = '$' + (compareAtPrice / 100).toFixed(2);
        } else {
            compareElement.style.display = 'none';
            compareElement.innerHTML = '';
        }
    }

    if (salePriceElement) {
        salePriceElement.innerHTML = '$' + (regularPrice / 100).toFixed(2);
    }
},
    variantsOnChange: function(type){
        let selectors;
        if (type === 'radio'){
            selectors = document.querySelectorAll('.product-form__input input[type="radio"]');
        }
        if (type === 'select'){
            selectors = document.querySelectorAll('.product-form__input select');
        }
        selectors.forEach(selector => {
            selector.addEventListener('change', event => {
                // Update Product Photo
                cr.updateProductPhoto(cr.matchingVariant(variants, cr.variantsSelected(type)).featured_media.preview_image.src);
                document.querySelector('input.product-variant-id').value = cr.matchingVariant(variants, cr.variantsSelected(type)).id;
                cr.updateSelectedPrice(cr.variantsSelected(type));
            });
        });
    },
    matchingVariant: function(variants, variantsSelected) {
        return variants.find(variant => {
            return variant.options.every((option, index) => {
                return option === variantsSelected[index];
            });
        });
    },
    updateProductPhoto: function(imageUrl){
        // Find slide with matching src
        const slickSlides = document.querySelectorAll('.slick-slide');
        slickSlides.forEach(slide => {
            const img = slide.querySelector('img');
            if (img) {
                const imgSrc = img.getAttribute('src');
                const protocolRemovedSrc = imageUrl.replace('https:', '');
                if (imgSrc === protocolRemovedSrc) {
                    let slideIndex = slide.getAttribute('data-slick-index');
                    // Use slickGoTo to go to that slide
                    $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', slideIndex);
                }
            }
        });
    },
    quantityChange: function(){
        const minButton = document.querySelector('.quantity-form .min');
        const plusButton = document.querySelector('.quantity-form .plus');
        const quantityInput = document.getElementById('Quantity');

        minButton.addEventListener('click', event => {
            event.preventDefault();
            let quantity = parseInt(quantityInput.value);
            if (quantity > 1) {
                quantity--;
                quantityInput.value = quantity;
            }
        });
        plusButton.addEventListener('click', event => {
            event.preventDefault();
            let quantity = parseInt(quantityInput.value);
            quantity++;
            quantityInput.value = quantity;
        });
    }
}

// Page is Ready
documentReady(function() {
    // Variant Radios
    if ( document.querySelector('variant-radios') !== null ){
        // Detect changes to radio buttons
        cr.variantsOnChange('radio');
    }

    // Variant Selects
    if ( document.querySelector('variant-selects') !== null ){
        // Detect changes to select elements
        cr.variantsOnChange('select');
    }

    // Quantity Change
    cr.quantityChange();

});


documentReady(function() {
    // Purane shoppay text ko utha kar price ke niche waale div me daalna
    const originalTerms = document.querySelector('.shoppay-text');
    const destination = document.getElementById('destination-shoppay-text');
    
    if (originalTerms && destination) {
        destination.appendChild(originalTerms);
    }
});



// // -----------------------
// // Product Customizations
// // -----------------------

// // DOM Ready
// function documentReady(fn) {
//     if (document.readyState !== 'loading') {
//         fn();
//     } else {
//         document.addEventListener('DOMContentLoaded', fn);
//     }
// }

// const cr = {
//     variantsSelected: function(type){
//         let variantSelectors;
//         if (type === 'radio'){
//             variantSelectors = document.querySelector('variant-radios');
//             const fieldsets = variantSelectors.querySelectorAll('fieldset');
//             let values = [];
//             fieldsets.forEach(fieldset => {
//                 const inputs = fieldset.querySelectorAll('input');
//                 inputs.forEach(input => {
//                     if (input.checked){
//                         values.push(input.getAttribute('value'));
//                     }

//                 });
//             });
//             return values;
//         }
//         if (type === 'select'){
//             variantSelectors = document.querySelectorAll('variant-selects select');
//             let values = [];
//             variantSelectors.forEach(select => {
//                 const selectedOption = select.options[select.selectedIndex];
//                 values.push(selectedOption.value);
//             });
//             return values;
//         }

//     },
//       // updateSelectedPrice: function(variantsSelected){
//     //     const compareAtPrice = parseInt(cr.matchingVariant(variants, variantsSelected).compare_at_price);
//     //     let regularPrice = parseInt(cr.matchingVariant(variants, variantsSelected).price);
//     //     const priceSaleElement = document.querySelector('.price__sale');
//     //     const salePriceElement = priceSaleElement.querySelector('.price-item--sale');
//     //     const compareElement = priceSaleElement.querySelector('s.price-item--regular');

//     //     compareElement.innerHTML = '$' + compareAtPrice / 100;
//     //     salePriceElement.innerHTML = '$' + regularPrice / 100;
//     // },
// updateSelectedPrice: function(variantsSelected) {
//     const matchingVariant = cr.matchingVariant(variants, variantsSelected);
//     // if (!matchingVariant) {
//     //     console.error("Matching variant not found!");
//     //     return;
//     // }

//     const compareAtPrice = parseInt(matchingVariant.compare_at_price) || 0;
//     let regularPrice = parseInt(matchingVariant.price) || 0;

//     const priceSaleElement = document.querySelector('.price__sale');
//     if (!priceSaleElement) {
//         console.error("Element '.price__sale' not found!");
//         return;
//     }

//     const salePriceElement = priceSaleElement.querySelector('.price-item--sale');
//     const compareElement = priceSaleElement.querySelector('s.price-item--regular');

//     if (!salePriceElement || !compareElement) {
//         console.error("Sale price or compare price element not found!");
//         return;
//     }

//     if (compareAtPrice > 0) {
//         compareElement.style.display = "inline";  // Show strikethrough price
//         compareElement.innerHTML = '$' + (compareAtPrice / 100).toFixed(2);
//     } else {
//         compareElement.style.display = "none";  // Hide if price is 0.00
//     }

//     salePriceElement.innerHTML = '$' + (regularPrice / 100).toFixed(2);
// },
//     variantsOnChange: function(type){
//         let selectors;
//         if (type === 'radio'){
//             selectors = document.querySelectorAll('.product-form__input input[type="radio"]');
          
//         }
//         if (type === 'select'){
//             selectors = document.querySelectorAll('.product-form__input select');
//         }

//          const addToCartBtn = document.getElementById('pdp-add-to-cart');
//          const atcParent = document.getElementsByClassName('add-to-cart-disable-wrapper');
//          const emailBtn = document.getElementById('emailMeWhenAvailableBtn');

//         selectors.forEach(selector => {
//             selector.addEventListener('change', event => {
//                 if (addToCartBtn) {
//                         // Hide the overlay div when Add to Cart is enabled
//                         if (atcParent) {
//                             atcParent[0].style.display = 'none';
//                             addToCartBtn.disabled=false;
//                         }
//                     }
//                     const selectedVariant = cr.matchingVariant(variants, cr.variantsSelected(type));
//                     if (selectedVariant.available == false) {
//                     // Show Email button when size selected
//                     if (emailBtn) {
//                         emailBtn.style.opacity = '1';
//                         emailBtn.style.pointerEvents = 'auto';
//                         emailBtn.style.height = '49px';
//                     }
//                 }
//                 // Update Product Photo
//                 //cr.updateProductPhoto(cr.matchingVariant(variants, cr.variantsSelected(type)).featured_media.preview_image.src);
//                 if(cr.matchingVariant(variants, cr.variantsSelected(type)) && cr.matchingVariant(variants, cr.variantsSelected(type)).featured_media && cr.matchingVariant(variants, cr.variantsSelected(type)).featured_media.preview_image)
//                     {
//                          cr.updateProductPhoto(cr.matchingVariant(variants, cr.variantsSelected(type)).featured_media.preview_image.src);
//                     }
//                     if(cr.matchingVariant(variants, cr.variantsSelected(type)))
//                     {
//                 document.querySelector('input.product-variant-id').value = cr.matchingVariant(variants, cr.variantsSelected(type)).id;
//                     }
//                 cr.updateSelectedPrice(cr.variantsSelected(type));
//             });
//         });
//     },
//     matchingVariant: function(variants, variantsSelected) {
//         return variants.find(variant => {
//             return variant.options.every((option, index) => {
//                 return option === variantsSelected[index];
//             });
//         });
//     },
//     updateProductPhoto: function(imageUrl){
//         // Find slide with matching src
//         const slickSlides = document.querySelectorAll('.slick-slide');
//         slickSlides.forEach(slide => {
//             const img = slide.querySelector('img');
//             if (img) {
//                 const imgSrc = img.getAttribute('src');
//                 const protocolRemovedSrc = imageUrl.replace('https:', '');
//                 if (imgSrc === protocolRemovedSrc) {
//                     let slideIndex = slide.getAttribute('data-slick-index');
//                     // Use slickGoTo to go to that slide
//                     $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', slideIndex);
//                 }
//             }
//         });
//     },
//     // quantityChange: function(){
//     //     const minButton = document.querySelector('.quantity-form .min');
//     //     const plusButton = document.querySelector('.quantity-form .plus');
//     //     const quantityInput = document.getElementById('Quantity');

//     //     minButton.addEventListener('click', event => {
//     //         event.preventDefault();
//     //         let quantity = parseInt(quantityInput.value);
//     //         if (quantity > 1) {
//     //             quantity--;
//     //             quantityInput.value = quantity;
//     //         }
//     //     });
//     //     plusButton.addEventListener('click', event => {
//     //         event.preventDefault();
//     //         let quantity = parseInt(quantityInput.value);
//     //         quantity++;
//     //         quantityInput.value = quantity;
//     //     });
//     // }
// }


// // Page is Ready
// documentReady(function() {
//     // Variant Radios
//     if ( document.querySelector('variant-radios') !== null ){
//         // Detect changes to radio buttons
//         cr.variantsOnChange('radio');
//     }

//     // Variant Selects
//     if ( document.querySelector('variant-selects') !== null ){
//         // Detect changes to select elements
//         cr.variantsOnChange('select');
//     }

//     // Quantity Change
//     //cr.quantityChange();

// });
// // ----------------------------
// // Initialize on page ready
// // ----------------------------
// documentReady(function() {


//             // const addToCartBtn = document.getElementById('pdp-add-to-cart');
//         const atcParent = document.getElementsByClassName('add-to-cart-disable-wrapper');




//     const addToCartBtn = document.getElementById('pdp-add-to-cart');
//     const atcWrapper = document.getElementsByClassName('atc-wrapper');
//     const variantHiddenInput = document.querySelector('input[name="id"]');
//     const emailBtn = document.getElementById('emailMeWhenAvailableBtn');

//             // Enable Add to Cart when variant selected
//                      if (addToCartBtn) {
//                         addToCartBtn.disabled = false;

//                         // Hide the overlay div when Add to Cart is enabled
//                         if (atcParent && atcParent.length > 0) {
//                             atcParent[0].style.display = 'none';
//                         }
//                     }

//     // Clear default selected variant on page load
//     if (variantHiddenInput) variantHiddenInput.value = '';

//     // Disable Add to Cart until a size is selected
//     if (addToCartBtn) addToCartBtn.disabled = true;
//     const atcbtnWrapper = document.createElement('div');
//     atcbtnWrapper.className = 'add-to-cart-disable-wrapper';
//     atcbtnWrapper.style.position = 'absolute';
//     atcbtnWrapper.style.height = '49px';
//     atcbtnWrapper.style.top = '0';
//     atcbtnWrapper.style.width = '100%';
//     atcbtnWrapper.style.zIndex = '9';
//     atcbtnWrapper.style.cursor = 'pointer';
//     if (addToCartBtn) addToCartBtn.insertAdjacentElement('afterend', atcbtnWrapper);

//      // Hide Email button initially
//     if (emailBtn) {
//         emailBtn.style.opacity = '0';
//         emailBtn.style.pointerEvents = 'none';
//         emailBtn.style.height = '0';
//     }

//     // // Hide Email button initially
//     // if (emailBtn) {
//     //     emailBtn.style.opacity = '0';
//     //     emailBtn.style.pointerEvents = 'none';
//     //     emailBtn.style.height = '0';
//     // }

//     // -----------------------------
//     // Create error message element (hidden initially)
//     // -----------------------------
//     const sizeMsg = document.createElement('div');
//     sizeMsg.className = 'Size_Error';
//     sizeMsg.textContent = 'Please select your size';
//     sizeMsg.style.color = '#EB001B';
//     sizeMsg.style.fontSize = '14px';
//     sizeMsg.style.marginBottom = '10px';
//     sizeMsg.style.textAlign = 'center';
//     sizeMsg.style.fontSize = '16px';
//     sizeMsg.style.cursor = '16px';
//     sizeMsg.style.display = 'none'; // hidden initially
//     if (addToCartBtn) addToCartBtn.insertAdjacentElement('afterend', sizeMsg);

//     // Add CSS for show class
//     const style = document.createElement('style');
//     style.innerHTML = `
//         .Size_Error.show {
//             display: block !important;
//         }
//     `;
//     document.head.appendChild(style);

//     // Variant change detection
//     if (document.querySelector('variant-radios') !== null) cr.variantsOnChange('radio');
//     if (document.querySelector('variant-selects') !== null) cr.variantsOnChange('select');


//     // -----------------------------
//     // Add click handler for disabled Add to Cart
//     // -----------------------------
//     if (addToCartBtn && atcWrapper) {
//         atcWrapper[0].addEventListener('click', function(e){
//             if (addToCartBtn.disabled) {
//                 e.preventDefault();
//                 sizeMsg.style.display = 'block'; // show message

//                 // Optional: auto-hide after 2.5 seconds
//                 setTimeout(() => {
//                     sizeMsg.style.display = 'none';
//                 }, 2500);
//             }
//         });
//     }
// });